import { Theme } from '@mui/material/styles';

export enum ReportStatus {
  Queued = 0,
  Processing = 1,
  Completed = 2,
  Failed = 3
}

export const getReportStatusDisplayName = (status: ReportStatus): string => {
  switch (status) {
  case ReportStatus.Queued:
    return 'Queued';
  case ReportStatus.Processing:
    return 'Processing';
  case ReportStatus.Completed:
    return 'Completed';
  case ReportStatus.Failed:
    return 'Failed';
  default:
    return 'Unknown';
  }
};

export const getReportStatusColor = (status: ReportStatus, theme: Theme): string => {
  switch (status) {
  case ReportStatus.Queued:
    return theme.palette.custom.blue[600]; 
  case ReportStatus.Processing:
    return theme.palette.custom.blue[400]; 
  case ReportStatus.Completed:
    return theme.palette.success.main; 
  case ReportStatus.Failed:
    return theme.palette.error.main; 
  default:
    return theme.palette.custom.gray[500]; 
  }
};
